var _rect, _rect2, _rect3, _rect4, _path, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileRtfInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 38,
    viewBox: "0 0 67 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.9206,
    height: 4.17582,
    transform: "translate(20.9204 12.9451) scale(1 -1)",
    fill: "#556080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 45.9206,
    height: 4.17582,
    transform: "translate(20.9204 21.2966) scale(1 -1)",
    fill: "#556080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 66.7936,
    height: 4.17582,
    transform: "translate(0.0473633 29.6484) scale(1 -1)",
    fill: "#556080"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 50.0952,
    height: 4.17582,
    transform: "translate(0.0478516 38) scale(1 -1)",
    fill: "#556080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6984 0V3.69705H10.5309V20.8791H6.19547V3.69705H0V0H16.6984Z",
    transform: "translate(0.0473633 0.41748)",
    fill: "#556080"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 45.9206,
    height: 4.17582,
    transform: "translate(20.9204 4.59351) scale(1 -1)",
    fill: "#556080"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileRtfInner);
export default __webpack_public_path__ + "static/media/file-rtf-inner.260e448e59407e4ec17685c44e59fefb.svg";
export { ForwardRef as ReactComponent };